// 钉钉微应用实名认证
<template>
  <!-- <no-ssr> -->
  <div class="ding-auth-sty">
    <h1 class="font-red">选择认证方式</h1>
    <div class="auth-content">
      <h3 class="titleII">
        <span class="title-icon"></span>
        <span v-if="loginInfo.corpAuthed != 1">当前认证企业：{{loginInfo.dingTalkCorpName}}</span>
        <span v-else>个人实名认证</span>
      </h3>
      <div class="auth-type-btns">
        <div
          :class="{'auth-fast':true, 'check-type':authType == typeOptions.dingBand}"
          @click="authType = typeOptions.dingBand"
        >
          <div>
            <h1>钉钉快速认证</h1>
            <span class="font-red">2分钟极速认证</span>
          </div>
          <img src="/images/icon/dingIcon1.png" alt="钉钉" />
        </div>
        <!-- <div
          :class="{'auth-fast':true, 'check-type':authType == typeOptions.saasBand}"
          @click="authType = typeOptions.saasBand"
        >
          <div>
            <h1>已有君子签账号</h1>
            <span>快速绑定</span>
          </div>
          <img src="/images/logoNew.png" alt="君子签" />
        </div> -->
      </div>
      <el-button
        type="primary"
        class="auth-band"
        @click="bandAuthBy"
      >{{`立即${authType == typeOptions.dingBand ? '认证' : '绑定'}`}}</el-button>
      <p 
        style="text-align: center;margin: 15px 0 0 156px;"
        @click="authType = typeOptions.saasBand;bandAuthBy();"
      >
        已有君子签账号？ <span style="color:#ec1c1c">立即绑定&gt;&gt;</span>
      </p>
    </div>
  </div>
  <!-- </no-ssr> -->
</template>
<script>
import { dingtalkApi } from "../../assets/js/http-serve/dingtalkApi";

// ⚠️ dingtalk-jsapi 只能在客户端（浏览器）中使用，服务端（Node.js/SSR）中会崩溃。
// 使用条件 require 确保仅在客户端加载。
let dd = null;
if (process.client) {
  dd = require('dingtalk-jsapi');
}

export default {
  layout: 'fullpage',
  data () {
    // 这里存放数据
    return {
      loginInfo: { dingTalkCorpName: '' },
      /** 认证方式  1 钉钉快速认证 2 saas绑定已有账号 */
      typeOptions: {
        dingBand: 1,
        saasBand: 2
      },
      authType: 1,
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    /** 立即绑定 */
    bandAuthBy () {
      this.authType == this.typeOptions.dingBand ? this.bandByDing() : this.bandBySaaS()
    },
    // 钉钉快速认证start
    bandByDing () {
      const { dingTalkCorpId: corpId, dingTalkUserId, corpAuthed } = this.loginInfo;
      // * 判断用户实名状态，如果企业【corpAuthed】未实名走企业逻辑，反之个人认证逻辑
      if (corpAuthed != 1) {
        let loading = this.$loading({
            lock: true,
            text: "认证中...",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, .5)"
          });
        // 企业未实名
        dingtalkApi.entAutoReplenish({ corpId, dingTalkUserId }).then(res => {
          if (!res.success) { return this.turnOther({ text: res.description }) }
          if (res.data.identityAuth === 1) this.$message.success('企业认证成功！')
          // 进入个人认证页面
          this.$router.replace({ path: '/login/middle', query: { corpId } })
        }).finally(()=>loading.close())
      } else {
        // 进入个人快速认证
        this.$router.push({ path: "/dingtalkUse/personAuth" })
      }
    },
    /** 企业完善资料 */
    turnOther ({ text }) {
      const _this = this, { dingTalkUserId, dingTalkCorpId: corpId } = this.loginInfo;
      _this.$confirm(
        text, '提示',
        {
          distinguishCancelAndClose: true,
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          let loading = _this.$loading({
            lock: true,
            text: "正在登录",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, .5)"
          });
          const param = {
            dingTalkUserId,
            corpId,
            // email (应该是有接口返回邮箱)
          }
          dingtalkApi.entReplenish(param).then(res => {
            if (!res.success) {
              if (res.code === '10302') return _this.$message.error('当前账号已在君子签注册，请前往绑定')
              return _this.$message.error(res.description)
            }
            _this.$router.push({
              path: "/dingtalkUse/middlePage",
              query: { ap: "/auth/authGuide", t: res.data.jzqToken }
            }, () => { });
          }).finally(() => {
            loading.close()
          })
          /* // 钉钉未完成实名
          _this.$router.push({ path: "/auth/dingTalkAuthComponents/dingentAuth" }); */
        })
        .catch(() => { });
    },
    // 钉钉快速认证end
    // saas 绑定 start
    bandBySaaS () {
      const { corpAuthed } = this.loginInfo;
      // * 判断用户实名状态，如果企业【corpAuthed】未实名走企业逻辑，反之个人认证逻辑
      this.$router.push({ path: corpAuthed != 1 ? '/auth/dingTalkAuthComponents/saasBand' : '/auth/dingTalkAuthComponents/personAuth/saasPersonBand' })
    },
    // saas 绑定 end
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    // dd.ready 已移至 mounted，mounted 只在客户端执行，避免 SSR 调用钉钉 API
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    // dd 仅客户端可用（process.client 守卫），mounted 不在服务端执行，此处安全调用
    if (dd) {
      dd.ready(() => {
        const session = sessionStorage
        this.loginInfo = JSON.parse(session.getItem("dingloginInfo"));
      })
    }
  },
}
</script>

<style lang='less' scoped>
@import (less) "../../assets/style/cssVariable.less"; // 引入公共css类
.check-type {
  box-shadow: 0px 0px 3px 1px @ebq-red !important;
}
.ding-auth-sty {
  width: 75vw;
  height: 90vh;
  padding-top: 20px;
  margin: 0 auto;
  background-color: @ebq-white;
  .font-red {
    color: @ebq-red;
  }
  h1 {
    text-align: center;
    font-size: 20px;
    margin-bottom: 20px;
  }
  .auth-content {
    width: 60vw;
    margin: 0 auto;
    .auth-type-btns {
      display: flex;
      justify-content: space-around;
      align-items: center;
      margin: 10vh 0;
      .auth-fast {
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-shadow: 0px 0px 3px 1px @ebq-grey-white;
        padding: 20px;
        width: 20vw;
        border-radius: 10px;
        cursor: pointer;
        > img {
          width: 145px;
        }
        &:hover {
          .check-type();
        }
      }
    }
    .auth-band {
      display: block;
      margin: 0 auto;
      width: 20vw;
    }
  }
  .titleII {
    display: flex;
    align-items: center;
    font-size: 15px;
    margin: 10vh 0;
  }
  .title-icon {
    display: inline-block;
    width: 5px;
    height: 15px;
    margin-right: 10px;
    background-color: @ebq-title-icon-color;
  }
}
</style>


// WEBPACK FOOTER //
// pages/auth/dingTalkAuth.vue